<script>
    import SettingColorPicker from '@/components/page-setting/SettingColorPicker.vue';
    import DefaultColor from '@/components/page-setting/DefaultColor.vue';

    export default {
        components: {
            DefaultColor: DefaultColor,
            SettingColorPicker: SettingColorPicker,
        },
        
    }
</script>


<template>
    <div class="setting_file_edit">
        <label
            class="setting_header"
        >Main Color:</label>
        <div class="color_container">
            <DefaultColor />
        </div>
        <label
            class="setting_header mt_20"
        >Custom Color:</label>
        <SettingColorPicker />
    </div>
</template>